export default {
    book: 'Boka {product}',
    age_limit: 'Endast för personer över {age} år',
    change_plan: 'Byt plan',
    upgrade_product: 'Uppgradera produkt',
    upgrade: 'Uppgradera',
    cancel_upgrade: 'Avbryt uppgradering',
    choose_product: 'Välj {product}',
    days: '{count} dag | {count} dagar',
    login_register: 'Logga in/Registrera',
    current: 'Nuvarande',
    keyless_benefits: {
        label: 'Direkt till bilen {0}',
        highlight: 'hyrtjänst™',
        list: {
            cant_lose_the_key: 'Full försäkring',
            zero_excess: 'Ingen självrisk',
            phone_as_a_key: 'Telefon som nyckel',
            straight_to_car: 'Ingen väntetid',
            no_queues: 'Inga köer',
            online_id_check: 'Online ID-kontroll',
            self_checkout: 'Självutcheckning',
        },
    },
};
